import React from 'react';
import ReactPlayer from 'react-player';

const Scenario4Video4 = () => {
    return (
        <div className='Scenario1VideoWrap Scenario1Video3'>
            <ReactPlayer url='https://youtu.be/llDmrzynD68' controls={true} />
        </div>
    );
}

export default Scenario4Video4;